import React from "react";
import { Spinner } from "../../components/bootstrap";

export default function LoadingIndicator(props) {
  return (
    <div style={{ display: "block", textAlign: "center", marginTop: 30 }}>
      <Spinner size="lg" />
    </div>
  );
}
